const name = 'survey'
export default name
